import { useCallback } from 'react'
import { customToast } from '@embracesbs/component-toast'
import { useApi } from './useApi'
import { usePreferences, UserPreferences } from '../Components/Context/PreferencesContext'

// Read + save user preferences. Updates apply optimistically (the theme flips
// instantly and PreferencesProvider caches to localStorage); the PUT persists
// them server-side and the change is reverted with a toast if it fails.
// Callers showing the failure toast must render <Toast /> on their page.
export const useUserPreferences = () => {
  const { preferences, setPreferences } = usePreferences()
  const { fetchApi } = useApi()

  const update = useCallback(
    async (partial: Partial<UserPreferences>) => {
      const previous = preferences
      const next = { ...preferences, ...partial }
      setPreferences(next)
      try {
        await fetchApi({ endpoint: '/api/preferences', method: 'PUT', body: next })
      } catch (error) {
        console.error('Failed to save preferences', error)
        setPreferences(previous)
        customToast.error('Could not save your preferences — change reverted')
      }
    },
    [preferences, setPreferences, fetchApi]
  )

  return { preferences, update }
}
